import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../libs/shared/ui/src/components/icon/icon';
import oneColorLogo from '../../assets/images/oneColorLogo.svg';

/*
 * Style.
 */

const StyledContentDiv = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-row-gap: 12px;
  justify-items: center;
  position: relative;
  width: 272px;
  padding: 16px 0px;
  color: ${(p) => p.theme.greys.white};
`;

const StyledDescriptionDiv = styled.div`
  text-align: center;
  font-size: 14px;
  line-height: 21px;
`;

const StyledSubdescriptionDiv = styled.div`
  font-size: 14px;
  line-height: 16px;

  a {
    color: ${(p) => p.theme.greys.white};
    text-decoration: underline;
  }
`;

const StyledInlineIcon = styled(Icon)`
  display: inline-block;
  margin-right: 7px;
  vertical-align: text-top;
`;

/*
 * Component.
 */

export const VisitorViewerSidebarFooter: FC = () => (
  <StyledContentDiv>
    <img src={oneColorLogo} alt="front-logo-one-color" />
    <StyledDescriptionDiv>
      <Trans id="visitor-sidebar-footer-v3">
        Front is a communications hub for building strong customer relationships.
      </Trans>
    </StyledDescriptionDiv>
    <StyledSubdescriptionDiv>
      <a href="https://front.com/why-front" target="_blank" rel="noreferrer">
        <Trans id="visitor-sidebar-footer-link-v3">See how it works</Trans>
      </a>{' '}
      <StyledInlineIcon name="externalLinkSmall" />
    </StyledSubdescriptionDiv>
  </StyledContentDiv>
);
